import { render } from "./newsId.vue?vue&type=template&id=430c5d0c&scoped=true"
import script from "./newsId.vue?vue&type=script&lang=js"
export * from "./newsId.vue?vue&type=script&lang=js"

import "./newsId.vue?vue&type=style&index=0&id=430c5d0c&scoped=true&lang=less"

import exportComponent from "D:\\STD7159\\源码管理\\前端\\stgd.oa.ows.inernetweb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430c5d0c"]])

export default __exports__